
export enum ComponentType {
    Program = 1,
    Report = 2,
    Setup = 3,
    //Dashboard = 4,
    Favourits = 5
}

